const styles = theme => ({
  coloredIcon: {
    color: theme.palette.secondary.main,
    padding: '0px 10px'
  }
});

export default styles;
